<template>
  <el-dialog
    :visible="recordDialogVisible"
    @close="closeDialog"
    width="1100px"
    destroy-on-close
  >
    <span slot="title">空投记录（任务ID：{{ checkTask.id }}）</span>
    <div class="record-actions">
      <el-select
        v-model="status"
        placeholder="请选择"
        size="small"
        class="record-select"
        @change="handleSearch"
      >
        <el-option label="全部" value=""></el-option>
        <el-option label="未发放" value="0"></el-option>
        <el-option label="已发放" value="1"></el-option>
        <el-option label="已删除" value="-1"></el-option>
      </el-select>
      <el-input
        v-model="userId"
        placeholder="请输入用户ID"
        size="small"
        class="record-input"
        clearable
      />
      <el-button type="primary" size="small" @click="handleSearch">
        搜索
      </el-button>
      <create-record @onSuccess="list" />
      <upload
        :drag="false"
        :showFileList="false"
        buttonText="导入"
        buttonType="default"
        :data="{ taskId: checkTask.id }"
        @uploaded="list"
        url="/la/admin/airdrop/record/import"
      />
      <el-button size="small"  target="_blank" @click="onExportClick" >导出Excel模板</el-button>
    </div> 
    <el-table :data="recordList">
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="amount" label="金额"> </el-table-column>
      <el-table-column prop="coinType" label="币种"> </el-table-column>
      <el-table-column prop="email" label="邮箱"> </el-table-column>
      <el-table-column prop="phone" label="电话"> </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <el-tag size="medium" :type="scope.row.__status.color">
            {{ scope.row.__status.text }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="handleExecuteRecord(scope.row.id)"
            v-if="scope.row.status === 0"
            >执行</el-button
          >
          <el-button
            size="mini"
            type="danger"
            @click="handleRemoveRecord(scope.row.id)"
            v-if="scope.row.status === 0"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="recordPagination.size"
      :page="recordPagination.page"
      :total="recordTotalCount"
      @pageChanged="handlePageChanged"
    >
    </pagination>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import Pagination from 'components/pagination';
import Upload from 'components/upload';
import CreateRecord from '../CreateRecord';

export default {
  name: 'AirdropRecord',
  components: {
    Pagination,
    CreateRecord,
    Upload
  },
  data() {
    return {
      loading: false,
      status: '',
      userId: '',
      downloadLink:''
    };
  },
  mounted () {
    
  },
  methods: {
    ...mapActions('airdrop', [
      'listRecords',
      'executeRecord',
      'removeRecord','templateDownload'
    ]),
    ...mapMutations('airdrop', ['setRecordDialogVisible']),
    closeDialog() {
      this.setRecordDialogVisible(false);
    },
    onExportClick() {  //导出的方法
      this.templateDownload().then(res=>{
      console.log('yemian-res',res);
      const link=document.createElement('a') 
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
      link.style.display = 'none'
      // 设置连接
      link.href = URL.createObjectURL(blob)  //将文件流转化为blob地址
      console.log('link-href',link.href);
      link.download = '空投记录统计报表'
      document.body.appendChild(link)
      // 模拟点击事件
      link.click()  //设置点击事件

    })
        },

    list(data = {}) {
      this.loading = true;
      this.listRecords({
        taskId: this.checkTask.id,
        userId: this.userId,
        status: this.status,
        ...this.recordPagination,
        ...data
      }).finally(() => {
        this.loading = false;
      });
    },
    handleSearch() {
      this.list({ page: 1 });
    },
    handlePageChanged(pagination) {
      this.list(pagination);
    },
    handleExecuteRecord(id) {
      // this.$confirm('确认要执行该记录吗？', '提示', {
      //   type: 'warning'
      // }).then(() => {
      //   this.executeRecord(id).then(() => {
      //     this.$message.success('执行成功！');
      //     this.list();
      //   });
      // });
      this.$prompt('请输入谷歌验证码','提示',{
        inputPlaceholder: '谷歌验证码',
        // inputValue: this.googleCode,
      }).then(res=>{
        console.log('reee',res);
        this.executeRecord({id,googleCode:res.value}).then(() => {
          this.$message.success('执行成功！');
          this.list();
        });

      })
    },
    handleRemoveRecord(id) {
      this.$confirm('确认要删除该记录吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.removeRecord(id).then(() => {
          this.$message.success('删除成功！');
          this.list();
        });
      });
    }
  },
  watch: {
    recordDialogVisible(val, oldVal) {
      if (val) {
        this.list({
          ...this.recordPagination,
          page: 1
        });
      }
    }
  },
  computed: {
    ...mapState('airdrop', [
      'recordDialogVisible',
      'recordPagination',
      'recordTotalCount',
      'checkTask'
    ]),
    ...mapGetters('airdrop', ['recordList'])
  }
};
</script>

<style lang="less" scoped>
.record-actions {
  display: flex;

  > * + * {
    margin-left: 10px;
  }

  .record-select {
    width: 100px;
  }

  .record-input {
    width: 200px;
  }
}
</style>
